import { IStockAtLocation } from 'gen/ApiClient';

export const quantityAtLocation = (stockAtLocations: IStockAtLocation[], locationId: string) => {
	return stockAtLocations.find(t => t.locationId === locationId)?.count ?? 0;
};
